/**
 * Admin 회원 영구삭제 버튼 – 이벤트 위임으로 바인딩.
 * Modal.confirm으로 확인 후 POST 처리. cursor-execution-rules: Form/Modal 활용.
 */
import { Modal } from "../../utils/Modal";

const SEL_BUTTON = "[data-admin-user-destroy]";

function getCsrfToken(): string {
  const fromForm = document.querySelector<HTMLInputElement>('input[name="_token"]');
  if (fromForm?.value) return fromForm.value;
  const fromHidden = document.getElementById("admin-users-csrf") as HTMLInputElement | null;
  return fromHidden?.value ?? "";
}

export function initAdminUserDestroyButtons(): void {
  document.body.addEventListener("click", async (e) => {
    const btn = (e.target as Element).closest<HTMLButtonElement>(SEL_BUTTON);
    if (!btn || btn.hasAttribute("disabled")) return;

    e.preventDefault();
    e.stopPropagation();

    const url = btn.getAttribute("data-destroy-url");
    const email = btn.getAttribute("data-user-email") ?? "";
    if (!url) return;

    const ok = await Modal.confirm(
      `회원을 영구 삭제하시겠습니까?\n이메일: ${email}\n해당 회원의 게시글·댓글도 함께 삭제됩니다.`,
      "영구 삭제 확인",
    );
    if (!ok) return;

    const token = getCsrfToken();
    if (!token) {
      await Modal.alert("보안 토큰을 찾을 수 없습니다. 페이지를 새로고침 후 다시 시도해주세요.");
      return;
    }

    btn.disabled = true;
    try {
      const formData = new FormData();
      formData.append("_token", token);
      formData.append("_method", "DELETE");
      const res = await fetch(url, {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      });
      const data = (await res.json()) as {
        result?: string;
        success?: boolean;
        msg?: string;
        message?: string;
        data?: { redirect?: string };
        redirect?: string;
      };
      const redirect = data?.data?.redirect ?? data?.redirect;
      if ((data?.result === "success" || data?.success) && redirect) {
        window.location.href = redirect;
        return;
      }
      await Modal.alert((data?.msg ?? data?.message ?? "삭제 처리에 실패했습니다.") as string);
    } catch {
      await Modal.alert("요청에 실패했습니다.");
    } finally {
      btn.disabled = false;
    }
  });
}
